module.exports = __webpack_public_path__ + "static/media/jeanie.972134a1.jpg";